import apiAxios from "helpers/apiAxios";
import { debounce, filterOptions } from "helpers/debounce";
import React, { useState } from "react"
import { Modal, Button, FormInput } from "components/common"
import AsyncSelect from 'react-select/async';
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const NewDepartmentModal = ({ showModal, setshowModal }) => {
  const [formData, setFormData] = useState({
    name: '',
    parent_id: '',
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      await apiAxios.post("/organization/departments", formData)
      toast.success(`Departments ${formData.name} has been created sucessfully.`)
      setshowModal(false)
    }
    catch (error) {
      toast.error(error.message)
    }
  }

  const handleCancel = () => {
    setshowModal(false)
  }

  const handleChange = ({ target }) => {
    let name = target.name;
    setFormData({ ...formData, [name]: target.value })
  }

  const debouncedFilterDepartments = debounce((inputValue, callback) => {
    filterOptions("/organization/departments", inputValue).then((filteredOptions) => {
      callback(filteredOptions);
    });
  }, 300);

  const loadDepartmentOptions = (inputValue, callback) => {
    debouncedFilterDepartments(inputValue, callback);
  };

  const debouncedFilterSite = debounce((inputValue, callback) => {
    filterOptions("/organization/sites", inputValue).then((filteredOptions) => {
      callback(filteredOptions);
    });
  }, 300);

  const loadSiteOptions = (inputValue, callback) => {
    debouncedFilterSite(inputValue, callback);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      title="New Department"
      backdropClick={false}
      footer={(
        <>
          <Button size="sm" type="submit" form="new-department-form">Save</Button>
          <Button size="sm" variant="danger" onClick={handleCancel}>Cancel</Button>
        </>
      )}
    >
      <form id="new-department-form" onSubmit={handleSubmit}>
        <h6 className="tw-text-blue-600 tw-font-semibold tw-text-sm tw-mb-3">Create a new Department</h6>
        <div className="tw-flex tw-flex-col tw-gap-3">
          <FormInput
            label="Department name"
            placeholder="Department name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />

          <div>
            <label className="tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5 tw-block">Parent</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadDepartmentOptions}
              closeMenuOnSelect={true}
              placeholder='Select...'
              classNamePrefix="react-select"
              className="tw-w-full"
              name="parent_id"
              onChange={(selectOptions) => setFormData({ ...formData, parent_id: selectOptions.value })}
            />
          </div>

          <div>
            <label className="tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5 tw-block">Site</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadSiteOptions}
              closeMenuOnSelect={true}
              placeholder='Select...'
              classNamePrefix="react-select"
              className="tw-w-full"
              name="site_id"
              onChange={(selectOptions) => setFormData({ ...formData, site_id: selectOptions.value })}
            />
          </div>
        </div>
      </form>
    </Modal>
  )
};

NewDepartmentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired
}

export default NewDepartmentModal;
